var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.839 0v79.65h-.321V0h.321zM113.853 0v79.65h-.321V0h.321zM96.51 0v79.65h-.32V0h.32zM79.168 0v79.65h-.321V0h.32zM61.182 0v79.65h-.32V0h.32zM43.839 0v79.65h-.321V0h.32zM25.853 0v79.65h-.32V0h.32z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.737 32.155a.983.983 0 100-1.965.983.983 0 000 1.965zM25.854 41.039a.983.983 0 100-1.966.983.983 0 000 1.966z",
    fill: "#52B2CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.854 69.314a.983.983 0 100-1.966.983.983 0 000 1.966z",
    fill: "#4179A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.854 73.29a.983.983 0 100-1.965.983.983 0 000 1.965zM43.48 62.415a.983.983 0 100-1.965.983.983 0 000 1.965zM61.11 59.37a.983.983 0 100-1.965.983.983 0 000 1.966z",
    fill: "#76CDE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.48 46.518a.983.983 0 100-1.966.983.983 0 000 1.966zM61.11 49.447a.983.983 0 100-1.966.983.983 0 000 1.966zM78.737 51.181a.983.983 0 100-1.966.983.983 0 000 1.966z",
    fill: "#4179A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.737 55.51a.983.983 0 100-1.965.983.983 0 000 1.965zM96.363 44.886a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#76CDE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.363 47.84a.983.983 0 100-1.965.983.983 0 000 1.966zM113.994 55.51a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#4179A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.994 60.353a.983.983 0 100-1.965.983.983 0 000 1.965zM131.62 63.764a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#76CDE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.62 61.683a.983.983 0 100-1.966.983.983 0 000 1.966z",
    fill: "#4179A8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.043 40.304L8.057 43.516l-.056-.317 17.985-3.211.057.316zM43.43 30.975l-17.664 8.993-.146-.287 17.664-8.992.146.286zM61.425 20.05L43.761 30.648l-.165-.275L61.26 19.775l.165.275z",
    fill: "#52B2CA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.086 48.623l-17.754-2.859.051-.317 17.754 2.858-.051.318z",
    fill: "#4179A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.139 58.546L43.505 61.63l-.055-.316 17.632-3.083.056.316zM78.638 54.684l-17.363 3.893-.07-.314 17.362-3.892.07.313z",
    fill: "#76CDE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.599 31.288L61.256 20.047l.175-.27 17.343 11.241-.175.27z",
    fill: "#52B2CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.721 50.358l-17.625-1.734.031-.32 17.626 1.734-.032.32z",
    fill: "#4179A8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.226 47.016l-17.632 3.327-.06-.315L96.166 46.7l.06.316z",
    fill: "#4179A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.278 44.041L78.646 54.556l-.165-.276 17.632-10.514.165.275z",
    fill: "#76CDE3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.123 19.079L78.78 31.604l-.188-.26L95.935 18.82l.188.26zM113.95 27.125l-17.985-7.707.126-.296 17.986 7.708-.127.296z",
    fill: "#52B2CA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.813 54.957L96.13 47.005l.132-.293 17.683 7.952-.132.293z",
    fill: "#4179A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.773 59.607L96.09 44.024l.212-.241 17.684 15.583-.213.24z",
    fill: "#76CDE3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.594 60.852l-17.684-6.173.106-.303 17.683 6.173-.105.303z",
    fill: "#4179A8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.616 62.94l-17.683-3.412.06-.315 17.684 3.41-.061.316z",
    fill: "#76CDE3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.484 54.614l-17.606-27.55.271-.173 17.606 27.55-.271.173z",
    fill: "#52B2CA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51 0v79.65h-.32V0h.32zM145 81.094H8.229v-.32H145v.32z",
    fill: "#EEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 71.588H0v1.965h5.26v-1.965zM5.26 43.903H0v1.966h5.26v-1.966zM5.26 57.746H0v1.965h5.26v-1.965zM5.26 30.061H0v1.966h5.26V30.06zM30.37 84.897h-9.025v1.965h9.024v-1.965zM47.995 84.897h-9.024v1.965h9.025v-1.965zM65.62 84.897h-9.024v1.965h9.025v-1.965zM83.253 84.897h-9.025v1.965h9.025v-1.965zM100.878 84.897h-9.025v1.965h9.025v-1.965zM118.503 84.897h-9.024v1.965h9.024v-1.965zM136.136 84.897h-9.025v1.965h9.025v-1.965z",
    fill: "#EEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 73.553a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#4179A8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 44.36a.983.983 0 100-1.966.983.983 0 000 1.965z",
    fill: "#52B2CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 77.645a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#76CDE3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.48 31.757a.983.983 0 100-1.966.983.983 0 000 1.966zM61.11 20.934a.983.983 0 100-1.966.983.983 0 000 1.966zM96.022 19.95a.983.983 0 100-1.965.983.983 0 000 1.966zM113.994 28.186a.983.983 0 100-1.966.983.983 0 000 1.966zM131.62 55.51a.983.983 0 100-1.965.983.983 0 000 1.965z",
    fill: "#52B2CA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.89 68.488L7.841 72.727l-.073-.313 18.05-4.24.072.314z",
    fill: "#4179A8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.893 72.463l-18.05 4.503-.077-.312 18.05-4.502.077.311z",
    fill: "#76CDE3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.806 45.383L25.982 68.43l-.255-.197 17.825-23.047.254.197z",
    fill: "#4179A8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.564 61.57L25.938 72.443l-.168-.273 17.625-10.875.169.273z",
    fill: "#76CDE3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 15.127H0v1.965h5.26v-1.965zM5.26 1.285H0V3.25h5.26V1.285z",
    fill: "#EEE"
  })));
}
export default SvgLine;